module.exports = __webpack_public_path__ + "static/media/pm_hc_physician_measure_4.6ecd8940.png";